import { useState } from "react";
import { getGeocode, getLatLng } from "use-places-autocomplete";

export const Debounce = ({ passData }) => {
  const [value, setValue] = useState("");
  const [predictions, setPredictions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getPredictions = async (input) => {
    if (!input) { setPredictions([]); return; }
    setIsLoading(true);
    try {
      const { suggestions } = await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input,
      });
      setPredictions(suggestions.map(s => ({
        description: s.placePrediction.text.text,
        placeId: s.placePrediction.placeId,
      })));
    } catch (err) {
      console.error('Autocomplete error:', err);
    }
    setIsLoading(false);
  };

  const handleSelect = async (address) => {
    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);
      setValue(address);
      setPredictions([]);
      passData(address, lat, lng);
    } catch (error) {
      console.error('Error getting geocode or lat/lng:', error);
    }
  };

  return (
    <div style={{ width: "300px", margin: "0 auto", textAlign: "center" }}>
      <input
        type="text"
        style={{
          width: "80%", padding: "10px", fontSize: "18px", color: "black",
          backgroundColor: "white", border: "1px solid #555",
          borderRadius: "4px", textAlign: 'center',
        }}
        placeholder="280 Ethan Allen Hwy"
        value={value}
        onChange={(evt) => {
          setValue(evt.target.value);
          getPredictions(evt.target.value);
        }}
      />
      <div style={{ marginTop: "20px", width: "300px", height: "200px", display: "flex", flexDirection: "column", marginBottom: "100px" }}>
        {!isLoading && predictions.length > 0 && (
          <ul style={{ listStyle: "none", margin: 0, padding: 0, width: "100%" }}>
            {predictions.map((item) => (
              <li
                key={item.placeId}
                onClick={() => handleSelect(item.description)}
                style={{
                  padding: "10px 12px",
                  borderBottom: "2px solid black",
                  cursor: "pointer",
                  textAlign: "center",
                  color: "black",
                  backgroundColor: "white",
                  fontSize: "14px",
                  fontWeight: '600',
                  transition: "background-color 0.15s ease",
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f5f5f5"}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = "white"}
              >
                {item.description}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};